import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { appliquerLangue } from "@/i18n";

const AuthContext = createContext(null);
const USER_CACHE_KEY = "chantiersplus_user";

function chargerLangueEntreprise() {
  api.get("/entreprise")
    .then((r) => appliquerLangue(r.data.langue || "fr"))
    .catch(() => {});
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem(USER_CACHE_KEY, JSON.stringify(r.data));
        chargerLangueEntreprise();
      })
      .catch((e) => {
        const offline = !navigator.onLine || e?.response?.status === 503;
        if (offline) {
          const cached = localStorage.getItem(USER_CACHE_KEY);
          setUser(cached ? JSON.parse(cached) : null);
        } else {
          setUser(null);
          localStorage.removeItem(USER_CACHE_KEY);
        }
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    localStorage.setItem(USER_CACHE_KEY, JSON.stringify(data));
    chargerLangueEntreprise();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    localStorage.setItem(USER_CACHE_KEY, JSON.stringify(data));
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem(USER_CACHE_KEY);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
